"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ProgressBar_styles_1 = require("./ProgressBar.styles");
const ProgressBar = (_a) => {
    var { currentValue, maxValue, size, progressBarProps } = _a, props = __rest(_a, ["currentValue", "maxValue", "size", "progressBarProps"]);
    const progressValid = checkProgressValid(currentValue, maxValue);
    if (!progressValid) {
        console.error("ProgressBar error: progress is not valid. currentValue must be >= 0 and <= maxValue and maxValue must be > 1");
        return null;
    }
    return (react_1.default.createElement(ProgressBar_styles_1.ProgressBarContainer, Object.assign({ complete: currentValue === maxValue, size: size }, props),
        react_1.default.createElement(ProgressBar_styles_1.StyledProgress, Object.assign({ id: "file", max: maxValue, value: currentValue }, progressBarProps))));
};
function checkProgressValid(currentValue, maxValue) {
    const isCurrentProgressValid = currentValue >= 0;
    const isMaxProgressValid = maxValue > 1;
    const isCurrentProgressInValidRange = currentValue <= maxValue;
    return (isCurrentProgressValid &&
        isCurrentProgressInValidRange &&
        isMaxProgressValid);
}
exports.default = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map